// types
import { Utils } from "helpers/utils";
import { ChatsActionTypes, ChatsState, MessageTypes } from "./types";
import { Const } from "const";
import { FILTER_CHAT_ROOM_TABS } from "../../constants";

export const INIT_STATE: ChatsState = {
  favourites: [],
  directMessages: [],
  channels: [],
  selectedChat: null,
  selectedContentTitle: null,
  chatUserDetails: {},
  chatUserConversations: {},
  isOpenUserDetails: false,
  channelDetails: {},
  archiveContacts: [],
  chatRoomLists: [],
  typingText: []
};

const Chats = (state = INIT_STATE, action: any) => {
  //console.log('Chats reducer:' + action.type);
  switch (action.type) {
    case ChatsActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case ChatsActionTypes.GET_FAVOURITES:
          return {
            ...state,
            favourites: action.payload.data,
            isFavouritesFetched: true,
            getFavouritesLoading: false,
          };
        case ChatsActionTypes.QUICK_REPLY_LOAD_ALL:
          return {
            ...state,
            quickReplies: action.payload.data
          }
        case ChatsActionTypes.GET_CHAT_ROOM_LIST:
          return {
            ...state,
            chatRoomLists: action.payload.data,
            isChatRoomListsFetched: true,
            getChatRoomListsLoading: false,
          };
        case ChatsActionTypes.LOAD_CUSTOMER_CONTENT:
          return {
            ...state,
            custContents: action.payload.data,
            isLoadCustomerContentFetched: true,
            isLoadCustomerContentLoading: false,
          };
        case ChatsActionTypes.ERP_GET_CUSTOMER_TASK: {
          // console.log('reducre ChatsActionTypes.ERP_GET_CUSTOMER_TASK:', action.payload);
          return {
            ...state,
            erpGetCustomerTaskLoading: false,
            erpGetCustomerTasks: action.payload.data
          }
        }
        case ChatsActionTypes.ERP_GET_PREV_TOP_NO_VOLUME: {
          return {
            ...state,
            erpGetPrevTopNoVolumeLoading: false,
            erpGetPrevTopNoVolumes: action.payload.data
          }
        }
        case ChatsActionTypes.ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45: {
          return {
            ...state,
            erpCateSizeNotSaleMoreThan45Loading: false,
            erpCateSizeNotSaleMoreThan45s: action.payload.data
          }
        }
        case ChatsActionTypes.ERP_CATE_INTEREST_NOT_SALE: {
          return {
            ...state,
            erpCateInterestNotSaleLoading: false,
            erpCateInterestNotSales: action.payload.data
          }
        }
        case ChatsActionTypes.ERP_CATE_NOT_SALE_MORE_THAN_60: {
          return {
            ...state,
            erpCateNotSaleMoreThan60Loading: false,
            erpCateNotSaleMoreThan60s: action.payload.data
          }
        }
        case ChatsActionTypes.GET_CONTENT_UNREAD_COUNT:
          // console.log('ChatsActionTypes.GET_CONTENT_UNREAD_COUNT:', action.payload);
          const contentTitleId = action.payload.data.contentTitleId;
          const unreadCount = action.payload.data.unreadCount;
          return {
            ...state,
            custContents: (state as any).custContents.map((custContent: any) => ({
              ...custContent,
              contentTitles: custContent.contentTitles.map((contentTitle: any) =>
                contentTitle.contentTitleId === contentTitleId
                  ? { ...contentTitle, unreadCount: unreadCount }
                  : contentTitle
              ),
            })),
          };
        case ChatsActionTypes.GET_CONTENT_UNREAD_COUNT_ALL:
          // console.log('ChatsActionTypes.GET_CONTENT_UNREAD_COUNT_ALL:', action.payload);
          const updatedData = action.payload.data;
          return {
            ...state,
            custContents: (state as any).custContents.map((custContent: any) => ({
              ...custContent,
              contentTitles: custContent.contentTitles.map((contentTitle: any) => {
                // Find matching data from API result
                const updatedItem = updatedData.find(
                  (item: any) => item.contentTitleId === contentTitle.contentTitleId
                );

                // If a match is found, update the unreadCount
                return updatedItem
                  ? { ...contentTitle, statusText: updatedItem.statusText }
                  : contentTitle;
              }),
            })),
          };

        case ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE:
          // console.log('ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE.Success:', action.payload);
          return {
            ...state,
            contentTitleInfo: action.payload.data.title,
            contentTitles: action.payload.data.list ?? [],
            selectedContentTitleLoading: false,
            selectedContentTitleKey: null,
            selectedContentTitleKeyLoading: false,
          }

        case ChatsActionTypes.GET_DIRECT_MESSAGES:
          return {
            ...state,
            directMessages: action.payload.data,
            isDirectMessagesFetched: true,
            getDirectMessagesLoading: false,
            isContactsAdded: false,
          };
        case ChatsActionTypes.GET_CHANNELS:
          return {
            ...state,
            channels: action.payload.data,
            isChannelsFetched: true,
            getChannelsLoading: false,
            isChannelCreated: false,
          };
        case ChatsActionTypes.ADD_CONTACTS:
          return {
            ...state,
            isContactsAdded: true,
            addContactsLoading: false,
          };
        case ChatsActionTypes.CREATE_CHANNEL:
          return {
            ...state,
            isChannelCreated: true,
            createChannelLoading: false,
          };
        case ChatsActionTypes.GET_CHAT_USER_DETAILS:
        case ChatsActionTypes.GET_CHAT_USER_DETAILS_2S:
          // console.log('Reducer GET_CHAT_USER_DETAILS_2S:', action.payload);
          return {
            ...state,
            chatUserDetails: action.payload.data.response,
            isUserDetailsFetched: true,
            getUserDetailsLoading: false,
          };
        case ChatsActionTypes.DEL_USER_FROM_GROUP:
          //console.log('DEL_USER_FROM_GROUP.SUCCESS', state, action.payload.data);
          // console.log('case ChatsActionTypes.DEL_USER_FROM_GROUP:', action);
          return {
            ...state,
            chatUserDetails: {
              ...state.chatUserDetails,
              members: action.payload.data
            }
          };
        case ChatsActionTypes.ADD_USER_TO_GROUP: {
          const { response, groupId, memberId, isAdd } = action.payload.data;
          return {
            ...state,
            chatUserDetails: {
              ...state.chatUserDetails,
              members: response
            }
          };
        }

        // case ChatsActionTypes.FIND_FOR_FILTER_CHATROOM: {
        //   // const keywordMode = action.payload.data.keywordMode;
        //   const { keywordMode, response } = action.payload.data;
        //   if (keywordMode == FILTER_CHAT_ROOM_TABS.CHAT_ROOM) return { ...state, filterRsChatRooms: response, filteringChatRooms: false };
        //   if (keywordMode == FILTER_CHAT_ROOM_TABS.SALES) return { ...state, filterRsSales: response, filteringSales: false };
        //   if (keywordMode == FILTER_CHAT_ROOM_TABS.CS) return { ...state, filterRsCs: response, filteringCs: false };
        //   if (keywordMode == FILTER_CHAT_ROOM_TABS.PROVINCE) return { ...state, filterRsProvince: response, filteringProvince: false };
        //   return {
        //     ...state
        //   }
        // }
        case ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_SALE: { return { ...state, filterRsSales: action.payload.data.response, filteringSales: false }; }
        case ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_CS: { return { ...state, filterRsCs: action.payload.data.response, filteringCs: false }; }
        case ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_PROVINCE: { return { ...state, filterRsProvince: action.payload.data.response, filteringProvince: false }; }

        case ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS:
          const minTime = action.payload.data.messages.length > 0 ? Math.min(...action.payload.data.messages.map((item: { time: string | number | Date; }) => new Date(item.time).getTime())) : "";
          const maxTime = action.payload.data.messages.length > 0 ? Math.max(...action.payload.data.messages.map((item: { time: string | number | Date; }) => new Date(item.time).getTime())) : "";
          const minTimeIso = minTime ? new Date(minTime).toISOString() : "";
          const maxTimeIso = maxTime ? new Date(maxTime).toISOString() : "";
          const divideMessage = Utils.InsertDividerDateInChatMessage(action.payload.data.messages);
          // console.log('devideMessage:', divideMessage);
          //console.log('GET_CHAT_USER_CONVERSATIONS.getUserConversationsLoading = false');
          //console.log('ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS:', action.payload);
          return {
            ...state,
            chatUserConversations: {
              ...action.payload.data,
              messages: divideMessage,
              minTime: minTimeIso,
              maxTime: maxTimeIso,
              //fetchType: 'initial',
              searchMsgId: action.payload.data.searchMsgId,
              fetchType: action.payload.data.searchMsgId ? "initial_search" : "initial"
            },
            isUserConversationsFetched: true,
            getUserConversationsLoading: false,
            isUserMessageSent: false,
            isMessageDeleted: false,
            isMessageForwarded: false,
          };

        case ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_PREV:
        case ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_NEXT:
          //console.log(action.payload);
          const msgExist = (state.chatUserConversations as any).messages;
          const payloadMsg = action.payload.data.messages;
          const msgNew = action.payload.data.messages;
          const fetchPrev = action.payload.actionType == ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_PREV;
          const fetchNext = action.payload.actionType == ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_NEXT;

          const msgMerge =
            fetchPrev
              ? new Map([...msgNew, ...msgExist].map((msg) => [msg.mId, msg]))
              : new Map([...msgExist, ...msgNew].map((msg) => [msg.mId, msg]))
          const updatedMessages = Array.from(msgMerge.values());
          // Recompute minTime and maxTime
          const minTime2 = Math.min(
            ...updatedMessages.map((item) => new Date(item.time).getTime())
          );
          const maxTime2 = Math.max(
            ...updatedMessages.map((item) => new Date(item.time).getTime())
          );

          const fetchType = action.payload.data.messages.length <= 0
            ? "none"
            : (fetchPrev ? "prev" : "next");
          const skipIndex = fetchType == "prev" ? (action.payload.data.messages.length - 1) : -1;

          const divideMsg = Utils.InsertDividerDateInChatMessage(updatedMessages);
          //console.log(updatedMessages.length + '/' + divideMsg.length);
          // console.log('updatedMessages:', updatedMessages);


          //console.log('GET_CHAT_USER_CONVERSATIONS.getUserConversationsLoading = false');
          return {
            ...state,
            chatUserConversations: {
              ...state.chatUserConversations,
              messages: divideMsg, //updatedMessages,
              minTime: new Date(minTime2).toISOString(),
              maxTime: new Date(maxTime2).toISOString(),
              fetchType: fetchType,
              skipIndex: skipIndex
            },
            isUserConversationsFetched: true,
            getUserConversationsLoading: false,
          };




        case ChatsActionTypes.ON_SEND_MESSAGE:
          return {
            ...state,
            isUserMessageSent: true,
          };
        case ChatsActionTypes.RECEIVE_MESSAGE:
        case ChatsActionTypes.RECEIVE_MESSAGE_FROM_USER:
          return {
            ...state,
            // chatUserConversations: action.payload.data,
            chatUserConversations: {
              ...action.payload.data,
              fetchType: 'none',
            },
          };
        case ChatsActionTypes.READ_MESSAGE:
          return {
            ...state,
            isMessageRead: true,
            // chatUserConversations: action.payload.data,
            chatUserConversations: {
              ...action.payload.data,
              fetchType: 'none',
            },
          };
        case ChatsActionTypes.ADD_MESSAGE_2S:
          // console.log('ChatsActionTypes.ADD_MESSAGE_2S:', action.payload);
          const messages = ((state.chatUserConversations as any).messages as any);
          const index = messages.findIndex((item: any) => item.mId == action.payload.data.message.mId);
          if (index !== -1) { // update eixsting
            return {
              ...state,
              chatUserConversations: {
                ...(state.chatUserConversations as any),
                // messages: (state.chatUserConversations as any)?.messages.map((item: any, idx: number) => {
                //   return idx === index ? { ...item, ...action.payload.data.message } : item
                // }),
                messages: (state.chatUserConversations as any)?.messages.map((item: any, idx: number) => {
                  if (idx === index) {
                    const { readerPcnt, ...restItem } = item; // Exclude readerPcnt
                    return { ...restItem, ...action.payload.data.message, readerPcnt }; // Keep original readerPcnt
                  }
                  return item;
                }),
                fetchType: action.payload.data.addType,
              },
            };
          } else { // add to existing
            return {
              ...state,
              chatUserConversations: {
                ...(state.chatUserConversations as any),
                /*
                messages: (state.chatUserConversations as any)?.messages
                  ? [...(state.chatUserConversations as any).messages, action.payload.data.message] // Add new message to the end of the array
                  : [action.payload.newMessage], // If Messages doesn't exist, initialize with newMessage
                  */
                messages: (() => {
                  const existingMessages = (state.chatUserConversations as any)?.messages || [];
                  const newMessage = action.payload.data.message;

                  // Check if there are existing messages
                  if (existingMessages.length > 0) {
                    // Get the date of the last message in the array
                    const lastMessage = existingMessages[existingMessages.length - 1];
                    const lastMessageDate = new Date(lastMessage.time).toDateString(); // Extract only the date part
                    const newMessageDate = new Date(newMessage.time).toDateString();   // Extract only the date part

                    // If dates are different, add a date divider
                    if (lastMessageDate !== newMessageDate) {
                      return [
                        ...existingMessages,
                        Utils.GetMessageDividerElement(newMessage.time),
                        newMessage,
                      ];
                    }
                  }

                  // If no messages exist or the dates are the same, just add the new message
                  return [...existingMessages, newMessage];
                })(),
                fetchType: action.payload.data.addType,
              },
            };
          }


        case ChatsActionTypes.DELETE_MESSAGE_2S:
          return { // work for delete mId from array
            ...state,
            chatUserConversations: {
              // Temporarily asserting chatUserConversations as any to suppress errors
              ...(state.chatUserConversations as any),
              messages: (state.chatUserConversations as any)?.messages
                ? (state.chatUserConversations as any).messages.filter(
                  (message: any) => message.mId !== 't123'
                )
                : [], // Fallback in case Messages is undefined
              fetchType: 'none',
            },
          };

        case ChatsActionTypes.DELETE_MESSAGE:
          return {
            ...state,
            isMessageDeleted: true,
          };
        case ChatsActionTypes.FORWARD_MESSAGE:
          return {
            ...state,
            isMessageForwarded: true,
          };
        case ChatsActionTypes.DELETE_USER_MESSAGES:
          return {
            ...state,
            isUserMessagesDeleted: true,
          };
        case ChatsActionTypes.GET_CHANNEL_DETAILS:
          return {
            ...state,
            chatUserDetails: { ...action.payload.data, isChannel: true },
            isChannelDetailsFetched: true,
            getUserDetailsLoading: false,
          };
        case ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT:
          return {
            ...state,
            isFavouriteContactToggled: true,
          };
        case ChatsActionTypes.GET_ARCHIVE_CONTACT:
          return {
            ...state,
            archiveContacts: action.payload.data,
            isArchiveContactFetched: true,
            isContactArchiveToggled: false,
          };
        case ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT:
          return {
            ...state,
            isContactArchiveToggled: true,
          };
        case ChatsActionTypes.DELETE_IMAGE:
          return {
            ...state,
            isImageDeleted: true,
          };
        case ChatsActionTypes.VIEW_MSG_MEMBER:
          return {
            ...state,
            viewMsgMembers: action.payload.data
          }

        default:
          return { ...state };
      }

    case ChatsActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case ChatsActionTypes.GET_FAVOURITES:
          return {
            ...state,
            isFavouritesFetched: false,
            getFavouritesLoading: false,
          };
        case ChatsActionTypes.GET_CHAT_ROOM_LIST:
          return {
            ...state,
            isChatRoomListsFetched: false,
            getChatRoomListsLoading: false,
          };
        case ChatsActionTypes.LOAD_CUSTOMER_CONTENT:
          return {
            ...state,
            isLoadCustomerContentFetched: false,
            isLoadCustomerContentLoading: true,
          };
        case ChatsActionTypes.GET_DIRECT_MESSAGES:
          return {
            ...state,
            isDirectMessagesFetched: false,
            getDirectMessagesLoading: false,
          };
        case ChatsActionTypes.GET_CHANNELS:
          return {
            ...state,
            isChannelsFetched: false,
            getChannelsLoading: false,
          };
        case ChatsActionTypes.ADD_CONTACTS:
          return {
            ...state,
            isContactsAdded: false,
            addContactsLoading: false,
          };
        case ChatsActionTypes.CREATE_CHANNEL:
          return {
            ...state,
            isChannelCreated: false,
            createChannelLoading: false,
          };
        case ChatsActionTypes.GET_CHAT_USER_DETAILS:
        case ChatsActionTypes.GET_CHAT_USER_DETAILS_2S:
          return {
            ...state,
            isUserDetailsFetched: false,
            getUserDetailsLoading: false,
          };
        case ChatsActionTypes.DEL_USER_FROM_GROUP:
          // console.log('case ChatsActionTypes.DEL_USER_FROM_GROUP:', action);
          return { ...state };

        case ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS:
          //console.log('GET_CHAT_USER_CONVERSATIONS.getUserConversationsLoading = false');
          return {
            ...state,
            chatUserConversations: {},
            isUserConversationsFetched: false,
            getUserConversationsLoading: false,
            isUserMessageSent: false,
            fetchType: 'none',
          };
        case ChatsActionTypes.ON_SEND_MESSAGE:
          return {
            ...state,
            isUserMessageSent: false,
          };
        case ChatsActionTypes.DELETE_MESSAGE:
          return {
            ...state,
            isMessageDeleted: false,
          };
        case ChatsActionTypes.FORWARD_MESSAGE:
          return {
            ...state,
            isMessageForwarded: false,
          };
        case ChatsActionTypes.DELETE_USER_MESSAGES:
          return {
            ...state,
            isUserMessagesDeleted: false,
          };
        case ChatsActionTypes.GET_CHANNEL_DETAILS:
          return {
            ...state,
            isChannelDetailsFetched: false,
            getUserDetailsLoading: false,
          };
        case ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT:
          return {
            ...state,
            isFavouriteContactToggled: false,
          };
        case ChatsActionTypes.GET_ARCHIVE_CONTACT:
          return {
            ...state,
            isArchiveContactFetched: false,
          };
        case ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT:
          return {
            ...state,
            isContactArchiveToggled: false,
          };
        case ChatsActionTypes.READ_CONVERSATION:
          return {
            ...state,
            isRead: false,
          };
        case ChatsActionTypes.DELETE_IMAGE:
          return {
            ...state,
            isImageDeleted: true,
          };
        default:
          return { ...state };
      }

    case ChatsActionTypes.UPDATE_IMAGE_ROTATE_INFO: {
      // console.log('Reducer UPDATE_IMAGE_ROTATE_INFO:', action.payload);
      return {
        ...state,
        chatUserConversations: {
          ...state.chatUserConversations,
          messages: (state.chatUserConversations as any).messages.map((message: any) =>
            message.mId === action.payload.mId
              ? {
                ...message,
                image: message.image.map((img: any) =>
                  img.fileId === action.payload.fileId
                    ? {
                      ...img,
                      downloadLink: action.payload.downloadLink,
                      downloadThumb: action.payload.downloadThumb,
                      degree: action.payload.degree,
                    }
                    : img
                ),
              }
              : message
          ),
        }
      }
    }

    case ChatsActionTypes.SET_TYPING_TEXT:
      const { selectedChat, typingText } = action.payload;
      const existingIndex = state.typingText.findIndex((entry) => entry.selectedChat === selectedChat);
      if (existingIndex !== -1) {
        // If it exists, update the `text` for the matching `selectedChat`
        return {
          ...state,
          typingText: state.typingText.map((entry, index) =>
            index === existingIndex
              ? {
                ...entry,
                typingText,
                tagNames: typingText.trim() === "" ? "" : entry.tagNames // Set tagNames to blank if typingText is empty
              }
              : entry
          )
        };
      } else {
        // If it doesn't exist, add a new entry
        return {
          ...state,
          typingText: [
            ...state.typingText,
            { selectedChat, typingText }
          ]
        };
      }

    case ChatsActionTypes.SET_TYPING_TAG: {
      // console.log('ChatsActionTypes.SET_TYPING_TAG:', action.payload);
      const { selectedChat, tagFormat } = action.payload;
      const existingIndex1 = state.typingText.findIndex((entry) => entry.selectedChat == selectedChat);
      // console.log(state.typingText);
      // console.log('existingIndex1 = ' + existingIndex1);
      if (existingIndex1 !== -1) {
        // If the entry exists, update its tagNames
        const existingEntry = state.typingText[existingIndex1];
        const delim = Const.DELIM_ROW;
        const updatedEntry = {
          ...existingEntry,
          tagNames: existingEntry.tagNames ? `${existingEntry.tagNames}${delim}${tagFormat}` : tagFormat,
        };
        // console.log({ existingEntry, updatedEntry });

        // Return a new state with the updated entry
        return {
          ...state,
          typingText: [
            ...state.typingText.slice(0, existingIndex1),
            updatedEntry,
            ...state.typingText.slice(existingIndex1 + 1),
          ],
        };
      } else {
        return {
          ...state
        }
      }
    }

    case ChatsActionTypes.QUICK_REPLY_SET_COUNT:
      const { quickReplyId, count } = action.payload;
      //console.log('ChatsActionTypes.QUICK_REPLY_SET_COUNT:', { quickReplyId, count });
      return {
        ...state,
        quickReplies: ((state as any).quickReplies ?? []).map((qc: any) => qc.quickReplyId == quickReplyId ? ({ ...qc, count: count }) : qc)
      };

    // case ChatsActionTypes.FIND_FOR_FILTER_CHATROOM: {
    //   // const keywordMode = action.payload.data.keywordMode;
    //   const { keywordMode } = action.payload;
    //   if (keywordMode == FILTER_CHAT_ROOM_TABS.CHAT_ROOM) return { ...state, filteringChatRooms: true };
    //   if (keywordMode == FILTER_CHAT_ROOM_TABS.SALES) return { ...state, filteringSales: true };
    //   if (keywordMode == FILTER_CHAT_ROOM_TABS.CS) return { ...state, filteringCs: true };
    //   if (keywordMode == FILTER_CHAT_ROOM_TABS.PROVINCE) return { ...state, filteringProvince: true };
    //   return {
    //     ...state
    //   }
    // }
    case ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_SALE: { return { ...state, filteringSales: true } }
    case ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_CS: { return { ...state, filteringCs: true } }
    case ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_PROVINCE: { return { ...state, filteringProvince: true } }

    case ChatsActionTypes.ERP_GET_CUSTOMER_TASK: {
      // console.log('reducre ChatsActionTypes.ERP_GET_CUSTOMER_TASK:', action.payload);
      return {
        ...state,
        erpGetCustomerTaskLoading: true
      }
    }

    case ChatsActionTypes.ERP_GET_PREV_TOP_NO_VOLUME: {
      return {
        ...state,
        erpGetPrevTopNoVolumeLoading: true
      }
    }

    case ChatsActionTypes.ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45: {
      return {
        ...state,
        erpCateSizeNotSaleMoreThan45Loading: true
      }
    }
    case ChatsActionTypes.ERP_CATE_INTEREST_NOT_SALE: {
      return {
        ...state,
        erpCateInterestNotSaleLoading: true
      }
    }
    case ChatsActionTypes.ERP_CATE_NOT_SALE_MORE_THAN_60: {
      return {
        ...state,
        erpCateNotSaleMoreThan60Loading: true
      }
    }

    case ChatsActionTypes.UPDATE_SENT_FLAG: {
      const { msgId } = action.payload;
      return {
        ...state,
        chatUserConversations: {
          ...state.chatUserConversations,
          messages: ((state.chatUserConversations as any).messages).map((message: any) => {
            //if (message.mId === msgId){
            if (message.mId === msgId && message.meta) { // 20250707
              message.meta.sent = true;
            }
            return message;
          })
        }
      }
    }

    case ChatsActionTypes.SET_RESP_EMOJI: {
      // console.log('ChatsActionTypes.SET_RESP_EMOJI:', action.payload);
      const { msgId, emojiName, emojiSymbol, currentMemberName } = action.payload;
      // Find the message with the given mId
      const updatedMessages = (state.chatUserConversations as any).messages.map((message: any) => {
        if (message.mId !== msgId) {
          return message; // No match, return as is
        }

        // Found the message, update its respEmoji
        const existingRespEmoji = message.respEmoji || [];
        const emojiIndex = existingRespEmoji.findIndex((emoji: any) => emoji.emojiName === emojiName);

        if (emojiIndex > -1) {
          // Emoji already exists, toggle the memberName
          const updatedMembers = existingRespEmoji[emojiIndex].memberNames.split("|").filter((name: any) => name); // Ensure no empty strings
          const memberExists = updatedMembers.includes(currentMemberName);

          const newMemberNames = memberExists
            ? updatedMembers.filter((name: any) => name !== currentMemberName).join("|") // Remove the member
            : [...updatedMembers, currentMemberName].join("|"); // Add the member

          const updatedEmoji = {
            ...existingRespEmoji[emojiIndex],
            memberNames: newMemberNames,
            memberCount: newMemberNames ? newMemberNames.split("|").length : 0,
          };

          const updatedRespEmoji = [
            ...existingRespEmoji.slice(0, emojiIndex),
            updatedEmoji,
            ...existingRespEmoji.slice(emojiIndex + 1),
          ];

          return { ...message, respEmoji: updatedRespEmoji };
        } else {
          // Emoji doesn't exist, add a new one
          const newEmoji = {
            emojiName,
            emoji: emojiSymbol, // Helper function to get emoji symbol
            memberCount: 1,
            memberNames: currentMemberName,
          };

          return { ...message, respEmoji: [...existingRespEmoji, newEmoji] };
        }
      });

      return {
        ...state,
        chatUserConversations: {
          ...state.chatUserConversations,
          messages: updatedMessages,
        },
      }
    }

    case ChatsActionTypes.UNSEND_MESSAGE: {
      const { msgId } = action.payload;
      // console.log('const { msgId } = action.payload;', msgId);
      const now = new Date();
      const updateMsg = (state.chatUserConversations as any).messages.map((message: any) => {
        if (message.mId === msgId) {
          message.isUnsend = true;
          message.unsendDateTime = now;
        }
        return message;
      });

      return {
        ...state,
        chatUserConversations: {
          ...state.chatUserConversations,
          messages: updateMsg
        }
      }
    }

    case ChatsActionTypes.SET_RESP_EMOJI_WHMSG: {
      const { msgId, respEmoji } = action.payload;
      // console.log('ChatsActionTypes.SET_RESP_EMOJI_WHMSG:', { msgId, respEmoji });
      const updateMsg = (state.chatUserConversations as any).messages.map((message: any) => {
        if (message.mId === msgId) { // not select message
          message.respEmoji = respEmoji;
        }
        return message;
      });
      // console.log(updateMsg);
      return {
        ...state,
        chatUserConversations: {
          ...state.chatUserConversations,
          messages: updateMsg
        }
      }
    }

    case ChatsActionTypes.ADD_MESSAGE_2S:
      // console.log('reducer.is2sAddingMessage = true');
      return {
        ...state,
        is2sAddingMessage: true
      }

    case ChatsActionTypes.ADD_MESSAGE_2S_SUCCESS:
      // console.log('reducer.is2sAddingMessage = false');
      return {
        ...state,
        is2sAddingMessage: false
      }

    case ChatsActionTypes.GET_FAVOURITES: {
      return {
        ...state,
        getFavouritesLoading: true,
        isFavouritesFetched: false,
      };
    }

    case ChatsActionTypes.SET_PREVIEW_ATTACHFILE: {
      return {
        ...state,
        previewAttach: action.payload
      }
    }

    case ChatsActionTypes.VIEW_MSG_MEMBER:
      return {
        ...state,
        viewMsgMemberModalOpen: action.payload.msgId ? true : false/*!(state as any).viewMsgMemberModalOpen*/
      }


    case ChatsActionTypes.GET_CHAT_ROOM_LIST: {
      return {
        ...state,
        getChatRoomListsLoading: true,
        isChatRoomListsFetched: false,
      };
    }

    case ChatsActionTypes.LOAD_CUSTOMER_CONTENT:
      return {
        ...state,
        isLoadCustomerContentFetched: false,
        isLoadCustomerContentLoading: true,
      };

    case ChatsActionTypes.GET_DIRECT_MESSAGES:
      return {
        ...state,
        isDirectMessagesFetched: false,
        getDirectMessagesLoading: true,
      };
    case ChatsActionTypes.GET_CHANNELS:
      return {
        ...state,
        isChannelsFetched: false,
        getChannelsLoading: true,
      };
    case ChatsActionTypes.ADD_CONTACTS:
      return {
        ...state,
        isContactsAdded: false,
        addContactsLoading: true,
      };
    case ChatsActionTypes.CREATE_CHANNEL:
      return {
        ...state,
        isChannelCreated: false,
        createChannelLoading: true,
      };
    case ChatsActionTypes.CHANGE_SELECTED_CHAT:
      //console.log('Reducer.ChatsActionTypes.CHANGE_SELECTED_CHAT :', action.payload);
      //       const waitUntil = Date.now() + 5000;
      // while (Date.now() < waitUntil) {
      //   // do nothing (CPU spins)
      // }

      return {
        ...state,
        selectedChat: action.payload,
        selectedContentTitle: null,
        selectedContentTitleLoading: false,
        selectedContentTitleKey: null,
        selectedContentTitleKeyLoading: false,
        chatUserDetails: { /* 20250226 */
          ...state.chatUserDetails,
          id: action.payload
        }
      };
    case ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE:
      // console.log('ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE:', action.payload);
      return {
        ...state,
        selectedChat: null,
        selectedContentTitle: action.payload.selectedContentTitle,
        selectedContentTitleLoading: action.payload.selectedContentTitle != null,
        selectedContentTitleKey: null,
        selectedContentTitleKeyLoading: false,
      };
    case ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE_KEYID:
      return {
        ...state,
        selectedContentTitleKey: action.payload.keyId,
        selectedContentTitleKeyLoading: true,
      };

    case ChatsActionTypes.REDUCE_CONTENT_TITLE_UNREAD:
      //console.log('ChatsActionTypes.REDUCE_CONTENT_TITLE_UNREAD:', action.payload);
      const { contentTitleId, keyId } = action.payload;

      // Step 1: Update the `isRead` property in `contentTitles`
      const updatedContentTitles = (state as any).contentTitles.map((content: any) =>
        content.keyId === keyId /*check only keyId because each time only one content title id active */
          ? { ...content, isRead: true }
          : content
      );

      // Step 2: Compute the new unread count
      const unreadCount = updatedContentTitles.filter((content: any) => !content.isRead).length;

      // Step 3: Update `custContents.contentTitles` for the corresponding `contentTitleId`
      const updatedCustContents = (state as any).custContents.map((custContent: any) => ({
        ...custContent,
        contentTitles: custContent.contentTitles.map((contentTitle: any) =>
          contentTitle.contentTitleId === contentTitleId
            ? { ...contentTitle, unreadCount }
            : contentTitle
        ),
      }));

      // Step 4: Return the updated state
      return {
        ...state,
        contentTitles: updatedContentTitles,
        custContents: updatedCustContents,
      };

    // // update unread
    // const rs1 = {
    //   ...state,
    //   contentTitles: (state as any).contentTitles.map((content: any) =>
    //     content.keyId === keyId /*check only keyId because each time only one content title id active */
    //       ? { ...content, isRead: true }
    //       : content,
    //   )
    // }
    // return rs1;

    // return {
    //     ...state,
    //     custContents: (state as any).custContents.map((content:any) => ({
    //         ...content,
    //         contentTitles: content.contentTitles.map((title:any) =>
    //             title.contentTitleId === contentTitleId
    //                 ? { ...title, unreadCount: Math.max(0, title.unreadCount - 1) }
    //                 : title
    //         ),
    //     })),
    // };      

    case ChatsActionTypes.GET_CHAT_USER_DETAILS:
    case ChatsActionTypes.GET_CHAT_USER_DETAILS_2S: {
      //console.log('GET_CHAT_USER_DETAILS_2S.getUserDetailsLoading = true');
      const { selectedChat, addToChatRoomList, loadProfile, loadErp } = action.payload;
      return {
        ...state,
        isUserDetailsFetched: false,
        getUserDetailsLoading: loadProfile/*true*/,
      };
    }
    case ChatsActionTypes.DEL_USER_FROM_GROUP:
      // console.log('case ChatsActionTypes.DEL_USER_FROM_GROUP:', action);
      return { ...state };

    case ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS:
      //console.log('Reducer:ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS:', action.payload);
      return {
        ...state,
        chatUserConversations: {
          ...state.chatUserConversations,
          // messages:[]
        },
        isUserConversationsFetched: false,
        getUserConversationsLoading: true,
        isUserMessageSent: false,
        selectedChat: action.payload.id, // 20250827 immediately changee for to prevent signal R remember old value
      };
    case ChatsActionTypes.TOGGLE_USER_DETAILS_TAB:
      let openTab = action.payload;
      if (openTab && !((state.chatUserDetails as any).id)) { // need to use details but no data 
        openTab = false;
      }
      return {
        ...state,
        isOpenUserDetails: openTab, //action.payload,
        chatUserDetails: openTab ? state.chatUserDetails : { id: (state.chatUserDetails as any)?.id }
      };
    case ChatsActionTypes.ON_SEND_MESSAGE:
      return {
        ...state,
        isUserMessageSent: false,
      };
    case ChatsActionTypes.DELETE_MESSAGE:
      return {
        ...state,
        isMessageDeleted: false,
      };
    case ChatsActionTypes.FORWARD_MESSAGE:
      return {
        ...state,
        isMessageForwarded: false,
      };
    case ChatsActionTypes.DELETE_USER_MESSAGES:
      return {
        ...state,
        isUserMessagesDeleted: false,
      };
    case ChatsActionTypes.GET_CHANNEL_DETAILS:
      return {
        ...state,
        isChannelDetailsFetched: false,
        getUserDetailsLoading: true,
      };
    case ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT:
      return {
        ...state,
        isFavouriteContactToggled: false,
      };
    case ChatsActionTypes.GET_ARCHIVE_CONTACT:
      return {
        ...state,
        isArchiveContactFetched: false,
      };
    case ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT:
      return {
        ...state,
        isContactArchiveToggled: false,
      };
    case ChatsActionTypes.DELETE_IMAGE:
      return {
        ...state,
        isImageDeleted: false,
      };
    case ChatsActionTypes.SET_GROUP_INVITE_CODE:
      // console.log('case ChatsActionTypes.SET_GROUP_INVITE_CODE:', action);
      return {
        ...state,
        chatUserDetails: {
          ...state.chatUserDetails,
          inviteCode: action.payload,
          inviteCodeExpired: false,
        }
      }
    case ChatsActionTypes.UPDATE_UNREAD_COUNT:
      // console.log('ChatsActionTypes.UPDATE_UNREAD_COUNT:', action.payload);
      return {
        ...state,
        chatRoomLists: state.chatRoomLists.map((item) =>
          item.id == action.payload.userOrGroupId ? {
            ...item,
            unreadCount: action.payload.unreadCount,
            unreadTagMe: action.payload.unreadTagMe,
            lastChatText: action.payload.lastChatText ?? item.lastChatText,
            lastChatTime: action.payload.lastChatTime ?? item.lastChatTime,
          } : item
        ),
      }
    case ChatsActionTypes.UPDATE_READ_PCNT_ON_MSG:
      // console.log('ChatsActionTypes.UPDATE_READ_PCNT_ON_MSG:', action.payload);
      return {
        ...state,
        chatUserConversations: {
          ...state.chatUserConversations,
          messages: (state.chatUserConversations as any).messages.map((message: any) => {
            // console.log('check pcnt on msg = ' + message.mId);
            // Find an update for the current message, if any
            const update = action.payload.find((update: any) => update.msgId === message.mId);
            // If there's an update, replace readCount; otherwise, keep the message as is
            return update ? { ...message, readerPcnt: update.readerPcnt } : message;
          }),
          fetchType: 'none',
        },
      }

    case ChatsActionTypes.UPDATE_SENDER_INFO: {
      const { senderId, profileImage } = action.payload;
      // console.log({ senderId, profileImage });
      return {
        ...state,
        chatUserConversations: {
          ...state.chatUserConversations,
          messages: (state.chatUserConversations as any).messages?.map((message: any) =>
            message.senderId === senderId
              ? { ...message, senderImg: profileImage }
              : message
          ),
        },
      }
    }

    case ChatsActionTypes.CHANGE_GROUP_FULL_NAME: {
      const { groupId, fullName } = action.payload;
      // console.log('ChatsActionTypes.CHANGE_GROUP_FULL_NAME:', { groupId, fullName });
      // Check if chatGroupId matches
      if ((state.chatUserDetails as any)?.userGroupId == groupId) {
        const displayName = fullName;
        return {
          ...state,
          chatUserDetails: {
            ...state.chatUserDetails,
            displayName,
          },
        };
      }
      return state; // No changes if chatGroupId doesn't match      
    }

    case ChatsActionTypes.SET_PROFILE_ACTIVE_TAB: {
      const { tab } = action.payload;
      // console.log('ChatsActionTypes.SET_PROFILE_ACTIVE_TAB:', tab);
      return {
        ...state,
        isOpenUserDetails: true,
        isOpenUserDetailsTab: tab
      }
    }

    default:
      return { ...state };
  }
};

export default Chats;
